import {
    OpType,
    SubscriptionMessage
} from '@aws-amplify/datastore';
import {
    isEditModeByDesignElementIdentifierAtomFamily,
    issueByIssueIdentifierSelectorFamily
} from '../design/document/state/DocumentState';

import { ContextAwareIdentifier } from '../design/document/ContextAwareIdentifier';
import { DataStore } from 'aws-amplify';
import { Issue } from '../../models';
import { ModelType } from '../design/document/ModelType';
import { StateContext } from '../design/document/state/StateContext';
import { elementFocusManager } from '../ui/ElementFocusManager';
import { useRecoilCallback } from 'recoil';

let subscription: ZenObservable.Subscription | undefined;

export const useIssueSubscription = () => {
    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(Issue, (issue) => issue.propertyId("eq", propertyId)).subscribe({
            next: (message: SubscriptionMessage<Issue>) => {
                handleIssueUpdate(message, StateContext.INSPECTION);
            },
            error: (error) => console.warn(error)
        });
    };

    const handleIssueUpdate = useRecoilCallback(({ set, reset, snapshot }) => async (message: SubscriptionMessage<Issue>, context: StateContext) => {
        const issueIdentifier = new ContextAwareIdentifier(message.element.id, context, ModelType.ISSUE);
        if (message.opType === OpType.DELETE) {
            reset(issueByIssueIdentifierSelectorFamily(issueIdentifier));
            return;
        }
        const issue = message.element;
        const existingIssue = await snapshot.getPromise(issueByIssueIdentifierSelectorFamily(issueIdentifier));
        if (existingIssue == null) {
            set(issueByIssueIdentifierSelectorFamily(issueIdentifier), issue);
            set(isEditModeByDesignElementIdentifierAtomFamily(issueIdentifier), false);
            elementFocusManager.scrollToElement();
            return issue;
        } else {
            if (existingIssue?.localLastUpdatedTime! >= issue.localLastUpdatedTime!) {
                // Ignore updates that are older than the current state
                return;
            }
            set(issueByIssueIdentifierSelectorFamily(issueIdentifier), issue);
            return issue;
        }
    });

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};